/**
 * @fileoverview Initial state for Watson Assistant module.
 *
 * @module store/modules/watson/state
 *
 * Defines default state for Watson integration including
 * intents, entities, dialog nodes, and workspace configuration.
 */

import { WatsonState } from "./types";

const state: WatsonState = {
  intents: [],
  entities: [],
  dialogNodes: [],
  workspace: {},
  isEditedObject: {},
};

export default state;
